import styled from "styled-components";
import { space } from "styled-system";

export const Spacer = styled.div(space);

export default Spacer;
